import { render, staticRenderFns } from "./DiscountRule.vue?vue&type=template&id=afdcfab4&scoped=true&"
import script from "./DiscountRule.vue?vue&type=script&lang=js&"
export * from "./DiscountRule.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRule.vue?vue&type=style&index=0&id=afdcfab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdcfab4",
  null
  
)

export default component.exports